import React, {useEffect, useState } from "react";
import Button         from '@material-ui/core/Button';
import TextField      from '@material-ui/core/TextField';
import Grid           from '@material-ui/core/Grid'
import MenuItem       from '@material-ui/core/MenuItem';
import queryString    from 'query-string'
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase       from'firebase/compat/app';
import 'firebase/compat/auth';

/**
 * ModalDiagnosis
 * 診療結果登録・更新・削除モーダル。
 * @param {object} props プロパティ
 * @param {string} props.DisplayName 表示対象者の名前
 * @param {string} props.MedicalRecordId 症状カードID
 * @param {function} [props.handleModalClose] 親画面のモーダルを閉じるコールバック
 * @param {function} [props.handleReloadModalClose] 親画面で再読込を伴うクローズ用コールバック
 */
export default function ModalDiagnosis(props) {
  const MEDICAL_SPECIALTY_OTHER = 'その他'

  // URL情報から更新・削除対象のDocIdを取得
  let docId = '';
  if(window.location.search){
    docId = queryString.parse(window.location.search).data||null;
  }

  /**
   * 現在日付を[MM月DD日（曜日）hh時mm分]形式で返す関数
   */
  const getDateDisplayFormat = () => {
    var now = new Date();
    return (now.getMonth()+1).toString().padStart(2, '0') + "月"
      + now.getDate().toString().padStart(2, '0') + "日（"
      + [ "日", "月", "火", "水", "木", "金", "土" ][now.getDay()] + "）"
      + now.getHours().toString().padStart(2, '0') + "時"
      + now.getMinutes().toString().padStart(2, '0') + "分"
  }

  const [ DisplayName                          ]  = useState(props.DisplayName)       // 表示対象者の名前
  const [ MedicalRecordId                      ]  = useState(props.MedicalRecordId)   // 症状カードID
  const [ ResultId                             ]  = useState(docId)                   // 診療結果ID(更新・削除用)
  const [ ConsultationTime,setConsultationTime ] = useState(getDateDisplayFormat())               // 受診時刻(自動入力)
  const [ HospitalName,    setHospitalName     ] = useState('') //病院名
  const [ MedicalSpecialty,setMedicalSpecialty ] = useState('') //診療科目
  const [ MedicalSpecialtyOther,setMedicalSpecialtyOther ] = useState('') //診療科目（その他入力）
  const [ DoctorName,      setDoctorName       ] = useState('') //先生の名前
  const [ Diagnosis,       setDiagnosis        ] = useState('') //診断結果
  const [ Instructions,    setInstructions     ] = useState('') //医者の指示
  const [ Note,            setNote             ] = useState('') //メモ
  const [ CreateTime,      setCreateTime       ] = useState('') //作成日時
  const [ ,                setUpdateTime       ] = useState('') //更新日時（値は未使用のためsetterのみ保持）

  /**
   * 画面上に表示される各要素の選択肢一覧
   * (下記の設定を変更すれば、render()部の修正は不要)
   */
  const choicesMap = {
    MedicalSpecialty: [ // 診療科目
      "内科",
      "外科",
      "小児科",
      "呼吸器科",
      "消化器科",
      "循環器科",
      "眼科",
      "耳鼻咽喉科",
      "皮膚科",
      MEDICAL_SPECIALTY_OTHER],
    Diagnosis: [ // 診断結果
      "経過観察",
      "要治療",
      "1週間以内に再来院",
      "1ヶ月以内に再来院",
      "処方箋のみ"],
    x: ["-"]
  }

  /**
   * Firestoreから登録済み診療結果を取得し、表示に反映する。
   */
  const ReadResult = async() => {

    // firestoreから現在の登録データを取得し、モーダル表示画面に反映
    if(ResultId){
      const db = firebase.firestore()

      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId)
      .get().then(function(doc) {
        if(doc.data()){
          const loadedMedicalSpecialty = doc.data().MedicalSpecialty || ''
          const isPresetMedicalSpecialty = choicesMap.MedicalSpecialty.includes(loadedMedicalSpecialty)

          setConsultationTime (doc.data().ConsultationTime    || '') //受診時刻
          setHospitalName     (doc.data().HospitalName        || '') //病院名
          if(loadedMedicalSpecialty && !isPresetMedicalSpecialty){
            setMedicalSpecialty(MEDICAL_SPECIALTY_OTHER)
            setMedicalSpecialtyOther(loadedMedicalSpecialty)
          } else {
            setMedicalSpecialty(loadedMedicalSpecialty)
            setMedicalSpecialtyOther('')
          }
          setDoctorName       (doc.data().DoctorName          || '') //先生の名前
          setDiagnosis        (doc.data().Diagnosis           || '') //診断結果
          setInstructions     (doc.data().Instructions        || '') //医者の指示
          setNote             (doc.data().Note                || '') //メモ
          setCreateTime       (doc.data().CreateTime.toDate() || '') //作成日時
          setUpdateTime       (doc.data().UpdateTime.toDate() || '') //更新日時
        }
      })
    }
  }

  //モーダルを非表示状態に切り替える
  const handleModalClose = () => {
    if(typeof props.handleModalClose == 'function'){
      props.handleModalClose() // 症状カード画面のモーダルを閉じる
    }
  }

  //モーダルを非表示状態に切り替え、症状カード画面で再読み込みする
  const handleReloadModalClose = () => {
    if(typeof props.handleReloadModalClose == 'function'){
      props.handleReloadModalClose() // 症状カード画面のモーダルを閉じ、画面内データを再読み込みする。
    }
  }

  /**
   * 画面入力値の変更ハンドラ。
   * `TextField.name` とステート setter を対応付けて処理を共通化。
   * @param {*} e 各選択肢のTextField要素
   */
  //
  const handleChange = (e) => {
    const { name, value } = e.target

    if(name === 'MedicalSpecialty'){
      setMedicalSpecialty(value)
      return
    }

    const setters = {
      ConsultationTime: setConsultationTime,
      HospitalName:     setHospitalName,
      MedicalSpecialtyOther: setMedicalSpecialtyOther,
      DoctorName:       setDoctorName,
      Diagnosis:        setDiagnosis,
      Instructions:     setInstructions,
      Note:             setNote,
    }
    const setter = setters[name]
    if (setter) setter(value)
  }

  /**
   * 現在日付を[YYYYMMDDhhmmss]形式で返す関数
   */
  const getDateIdFormat = () => {
    var now = new Date();
    return "" + now.getFullYear()
      + (now.getMonth()+1).toString().padStart(2, '0')
      + now.getDate().toString().padStart(2, '0')
      + now.getHours().toString().padStart(2, '0')
      + now.getMinutes().toString().padStart(2, '0')
      + now.getSeconds().toString().padStart(2, '0');
  }

  /**
   * 削除ボタン押下時の処理
   */
  const handleDeleteButtonClick = () => {
    // 削除実行の確認用ポップアップ
    if (!window.confirm("診断結果を削除します")) {
      alert("削除をキャンセルしました");
      // this.props.history.goBack();
      return;
    }

    deleteResult();
  }

  const deleteResult = async() => {
    let db = firebase.firestore()

    //削除処理は前画面からデータを引き継いでいる場合のみ実行可能
    if(ResultId){
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId).delete()
      .then(()=>{
        alert("診察結果を削除しました")
      })
      .catch(function(error) {
        alert("削除に失敗しました")
        console.log("診察結果の削除に失敗しました ", error);
      });
    }
    handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
    //this.props.history.goBack();
  }

  /**
   * 登録ボタン押下時の処理
   */
  const handleRegistButtonClick = () => {
    registResult()
  }

  /**
   * 診療結果を新規作成または更新してFirestoreへ保存する。
   */
  const registResult = async() => {
    let db = firebase.firestore()
    let doc_id = getDateIdFormat()
    const medicalSpecialtyToSave = MedicalSpecialty === MEDICAL_SPECIALTY_OTHER
      ? (MedicalSpecialtyOther || '')
      : (MedicalSpecialty || '')

    const setData = {  // NULLチェックは右記のショートハンドで実施([条件式]?[true]:[false] → ||)
      // BodyTemperature:  BodyTemperature  || '', //体温（数値型）
      ConsultationTime: ConsultationTime || '', //受診時刻
      CreateTime:       CreateTime       || firebase.firestore.FieldValue.serverTimestamp(),  //作製時刻（firebaseのサーバー時刻）
      // DeleteFlag: false, //削除フラグ
      Diagnosis:        Diagnosis        || '', //診断結果
      DoctorName:       DoctorName       || '', //先生の名前
      HospitalName:     HospitalName     || '', //病院名
      Instructions:     Instructions     || '', //医者の指示
      MedicalSpecialty: medicalSpecialtyToSave, //診療科目
      Note:             Note             || '', //メモ
      UpdateTime:       firebase.firestore.FieldValue.serverTimestamp(), //作製時刻（firebaseのサーバー時刻）
    }

    if(ResultId){ //更新時
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(ResultId)
      .set(setData)
      .then((result)=>{
        alert("診察結果を更新しました")
        doc_id = ResultId
        handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
    })
      .catch(function(error) {
        alert("更新に失敗しました")
        console.log("診察結果の更新に失敗しました ", error);
      });
    }
    else{ //新規登録時
      await db.collection("MedicalRecords").doc(MedicalRecordId)
      .collection("MedicalResults").doc(doc_id)
      .set(setData).then((result)=>{
          alert("診察結果を登録しました")
          handleReloadModalClose() //モーダル画面を閉じ、画面データの再読み込みを行う。
      })
      .catch(function(error) {
        alert("登録に失敗しました")
        console.log("診察結果の登録に失敗しました ", error);
      });
    }
  }

  useEffect(() => { //ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    console.log("useEffect: ReadResult")
    ReadResult()
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => { //ページを離れる際に実行
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, [])


  return (
    <React.Fragment>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={2}>
        <Grid item xs={12}>
          診察：先生に言われたことを残しておきましょう
        </Grid>
        <Grid container item xs={12} justifyContent="flex-end">
          {DisplayName}
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth required id="ConsultationTime" label="受診日時" name="ConsultationTime" value={ConsultationTime} onChange={(e)=>handleChange(e)}/>
        </Grid>
      
        <Grid item xs={12}>
          <TextField fullWidth id="inputHospitalName" label="受診医療機関" name="HospitalName" value={HospitalName} onChange={(e)=>handleChange(e)}/>
        </Grid>
        <Grid item xs={12}>
          <TextField select fullWidth id="selMedicalSpecialty" label="診療科" name="MedicalSpecialty" value={MedicalSpecialty} onChange={(e)=>handleChange(e)}>
            {choicesMap.MedicalSpecialty.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={12} style={{ display: (MedicalSpecialty === MEDICAL_SPECIALTY_OTHER ? 'block' : 'none') }}>
          <TextField
            fullWidth
            id="inputMedicalSpecialtyOther"
            label="診療科（その他）"
            name="MedicalSpecialtyOther"
            value={MedicalSpecialtyOther}
            onChange={(e)=>handleChange(e)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth id="inputDoctorName" label="先生の名前" name="DoctorName" value={DoctorName} onChange={(e)=>handleChange(e)}/>
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline minRows={5} id="selDiagnosis" label="診察結果" name="Diagnosis" value={Diagnosis} onChange={(e)=>handleChange(e)}/>
          {/* <TextField select fullWidth id="selDiagnosis" label="診察結果" name="Diagnosis" value={Diagnosis} onChange={(e)=>handleChange(e)}>
            {choicesMap.Diagnosis.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
          </TextField> */}
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline minRows={5} id="inputInstructions" label="先生からの指示" name="Instructions" value={Instructions} onChange={(e)=>handleChange(e)}/>
        </Grid>

        <Grid item xs={12}>
          <TextField fullWidth multiline minRows={5} id="inputNote" label="メモ" name="Note" value={Note} onChange={(e)=>handleChange(e)}/>
        </Grid>
      </Grid>
      <p> </p>
      <Grid container justifyContent="space-between" alignItems="flex-start">
        <div style={{display: (ResultId ? 'block' : 'none')}}> {/* 診断情報が登録済みの場合のみ削除ボタンを表示する */}
          <Button variant="outlined" color="secondary" onClick={()=>handleDeleteButtonClick()}>削除</Button>
        </div>
        <Button variant="outlined" color="primary" onClick={()=>handleModalClose()}>キャンセル</Button>
        <Button variant="outlined" color="primary" onClick={()=>handleRegistButtonClick()}>登録</Button>
      </Grid>
    </React.Fragment>
  );
}
